// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".banner a,.banner p{text-transform:uppercase;color:#fff}.banner a{font-weight:700}.banner .message{display:flex;align-items:center}.banner .message svg{transition:.25s;margin-left:13px}.banner .message:hover svg{transform:translateX(3px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
